"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QueueProgress = void 0;
const FSIServerClientUtils_1 = require("./FSIServerClientUtils");
const QueueItem_1 = require("./QueueItem");
const TaskProgress_1 = require("./TaskProgress");
class QueueProgress extends TaskProgress_1.TaskProgress {
    constructor(queue) {
        super();
        this.task = new TaskProgress_1.TaskProgress();
        this.currentItem = new QueueItem_1.QueueItem(queue, -1, "", []);
    }
    adjustTimeStart(ms) {
        this.task.timeStart += ms;
        this.timeStart += ms;
    }
    calcTotal() {
        this.task.timeElapsed = FSIServerClientUtils_1.FSIServerClientUtils.NOW() - this.task.timeStart;
        if (this.task.timeElapsed > 0 && this.task.percent > 0) {
            const rate = this.task.percent / this.task.timeElapsed;
            this.task.etaMS = (100 - this.task.percent) / rate;
            this.task.eta = FSIServerClientUtils_1.FSIServerClientUtils.FORMAT_TIME_PERIOD(this.task.etaMS);
        }
        this.timeElapsed = FSIServerClientUtils_1.FSIServerClientUtils.NOW() - this.timeStart;
        this.percent = 100 * (this.pos - 1) / this.length
            + this.task.percent / this.length;
    }
}
exports.QueueProgress = QueueProgress;
